import { ROUTES_NAMES } from '@/constants';
import store from '@/store';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

export const beforeEnterLogoutFederatedRoute = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): void => {
  const clientId = sessionStorage.getItem('clientID');
  const redirectURI = sessionStorage.getItem('redirectURI');

  if (!clientId || !redirectURI) {
    return next({ name: ROUTES_NAMES.error });
  }

  store.dispatch('setClientID', clientId);
  store.dispatch('setRedirectURI', redirectURI);
  next();
};
